// This file is the single source of truth for your backend URLs.
// It automatically uses the production URL from your Netlify environment variables when deployed,
// and falls back to the local URL for development.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// This derives the base URL for Socket.IO from the main API_URL.
export const SOCKET_URL = API_URL.replace('/api', '');
